import script from "./AuthManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./AuthManagement.vue?vue&type=script&setup=true&lang=js"

import "./AuthManagement.vue?vue&type=style&index=0&id=aaf1f0ec&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-aaf1f0ec"]])

export default __exports__